(($)=>{
  const $document = $(document);
  const storeCurrencyCode = $('.js-store-currency-code').val();
  const sessionStorageProductClick = 'datalayer:product:click';

  /* ------- Add Product To Cart ------- */
  const addToCartObjectTemplate = {
    'event': 'eec.addToCart',
    'ecommerce': {
      'currencyCode': '', // Currency (eg USD)
      'add': {
        'products': [{
          'name': '', // Product Name (eg Shirt1)
          'id': '', // Product ID (eg 123)
          'price': '', // Product Price (eg 120)
          'brand': '', // Product Brand (eg Google)
          'category': '', // Product Category (eg Apparel)
          'variant': '', // Product Variant (eg Blue)
          'quantity': '' // Product Quantity (eg 1)
        }]
      }
    }
  };

  $document.on('touchstart click', '[data-add-to-cart]', function(event) {
    // update event listeners to target new buttons being added to cart for product being added
    // event.preventDefault();
    const $this = $(this);
    $this.addClass('is-clicked');

    setTimeout(() => {
      $this.removeClass('is-clicked');
    }, 300);

    if ($this.hasClass('is-clicked')) {
      const $form = $this.closest('form');

      if ($form.length) {
        const objectTemplate = JSON.parse(JSON.stringify(addToCartObjectTemplate));
        const productOverview = $this.closest('product-overview')[0];
        if(! productOverview){
          console.log('data-layer-triggers [data-add-to-cart], no product page not found. Exiting');
          return
        }

        const currentVariant = productOverview.getVariant();


        const variantId = currentVariant.id;
        const quantity = 1;

        const singleProduct = objectTemplate.ecommerce.add.products[0];
        objectTemplate.ecommerce.currencyCode = storeCurrencyCode;
        singleProduct.quantity = parseInt(quantity);
        fetch(`${window.theme.routes.root_url}variants/${variantId}.json`)
          .then(response => response.json())
          .then(async (response) => {
            console.log(response);
            const productInfo = response.product_variant;
            const productData = await getProductById(productInfo.product_id);
            singleProduct.price = parseInt(productInfo.price);
            singleProduct.variant = productInfo.title;
            singleProduct.id = productInfo.product_id;
            singleProduct.name = productData.title;
            singleProduct.category = productData.type;
            singleProduct.brand = productData.vendor;
            dataLayer.push(objectTemplate);
          })
      }
    }
  })

  /**
   * Get product info by id
   * @param  {Number} id
   * @returns {Object}
   */
  async function getProductById(id) {
    try {
      const response = await fetch(`${window.theme.routes.root_url}search/suggest.json?q=id:${id}&resources[type]=product`);
      const data = await response.json();

      return data.resources.results.products[0];
    } catch (error) {
      console.log(error);
    }
  }

  /* ------- Product link clicks ------- */

  // Check if user previously clicked a link using session storage
  // Send product data to dataLayer
  if(sessionStorage.getItem(sessionStorageProductClick)){

    const data = JSON.parse(sessionStorage.getItem(sessionStorageProductClick));
    const productHandle = data.productHref.replace('/products/', '').split('?')[0];
    sessionStorage.removeItem(sessionStorageProductClick);

    fetch(`${window.theme.routes.root_url}products/${productHandle}.js`)
      .then(response => response.json())
      .then(response => {
        const productTitle = response.title;
        const productId = response.id;
        const productPrice = parseInt(response.price / 100);
        const productVendor = response.vendor;
        const productType = response.type;

        dataLayer.push({
          'event': 'eec.productClick',
          'ecommerce': {
            'click': {
              'actionField': {'list': ''},
              'products': [{
                'name': productTitle,
                // Optional list property (eg Search Results)
                // Name or ID is required.
                'id': productId,
                'price': productPrice,
                'brand': productVendor,
                'category': productType,
                'variant': '',
                'position': data.currentPath
              }]
            }
          }
        });
      });
  }

  /**
    * User clicks on a product link and the prodct handle is saved to storage
    */
  $document.on('click', 'a[href^="/products/"]', function() {
    sessionStorage.setItem(sessionStorageProductClick, JSON.stringify({
      currentPath: location.pathname,
      productHref: $(this).attr('href')
    }));
  })

  /* ------- Remove Product From Cart ------- */
  // Measure the removal of a product from a shopping cart.
  const removalObjectTemplate = {
    'event': 'eec.removeFromCart',
    'ecommerce': {
      'currencyCode': storeCurrencyCode, // Currency (eg USD)
      'remove': { // 'remove' actionFieldObject measures.
        'products': [{ // removing a product to a shopping cart.
          'name': '', // Product Name (eg Shirt1)
          'id': '', // Product ID (eg 123)
          'price': '', // Product Price (eg 120)
          'brand': '', // Product Brand (eg Google)
          'category': '', // Product Category (eg Apparel)
          'variant': '', // Product Variant (eg Blue)
          'quantity': '' // Product Quantity (eg 1)
        }]
      }
    }
  };

  $document.on('click', '.cart-item .button-remove', function() {
    const $this = $(this);
    const $item = $this.closest('.cart-item');
    findBasicProductInfoAndPush($item);
  })

  $document.on('click', '.cart-item .quantity__button--left', function() {
    const $this = $(this);
    const $item = $this.closest('.cart-item');
    findBasicProductInfoAndPush($item, false);
  });

  function pushFlickityEvent(currentTarget) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_plp_card_image",
      ecommerce: {
      page_path : window.location.pathname,
      items: [
        {
          item_id: currentTarget.variant.id,
          item_name:  currentTarget.variant.product_title,
          item_image_url: currentTarget.variant.featured_image,
        }]
      }
    });
  }

  $('product-card').on( 'dragEnd.flickity', function( event ) {
    pushFlickityEvent(event.currentTarget); 
  });
  
  $(document).on('click', '.product-card .flickity-prev-next-button', function(event) {
    const productCard = $(this).closest('product-card')[0]; 
    pushFlickityEvent(productCard);
  });  

  $document.on('click', '.cart-item .quantity__button--right', function() {
    const $this = $(this);
    const $item = $this.closest('.cart-item');
    findBasicProductInfoAndPush($item, false, true);
  });

  /**
   * Find basic product info and push
   * @param  {Jquery Element} $item
   * @param  {Boolean} isCloseButton=true
   * @returns {Void}
   */
  function findBasicProductInfoAndPush($item, isCloseButton = true, addToCart = false) {
    const removalObjectInstance = JSON.parse(JSON.stringify(removalObjectTemplate));
    const productObject = removalObjectInstance.ecommerce.remove.products[0];
    const productHandle = $item.find('a[href^="/products/"]').attr('href').replace('/products/', '').split('?')[0];

    productObject.variant = $item.find('.cart-item__title').text();
    productObject.price = parseInt($item.find('.cart-item__price').text().replace('$', ''));
    const storedQunatityInputValue = parseInt($item.find('.cart-item__quantity')[0]?.querySelector('.js-qty-span').innerText) || 1;

    if (isCloseButton) {
      // Remove from cart button
      productObject.quantity = storedQunatityInputValue;

      fetch(`${window.theme.routes.root_url}products/${productHandle}.json`)
        .then(response => response.json())
        .then(response => {
          productObject.name = response.product.title;
          productObject.brand = response.product.vendor;
          productObject.id = response.product.id;
          productObject.category = response.product.product_type;

          dataLayer.push(removalObjectInstance);
        })
    } else {
      const $minusBtn = $item.find('.quantity__button--left');
      productObject.quantity = 1;

      if (addToCart) {
        // Plus button
        fetch(`${window.theme.routes.root_url}products/${productHandle}.json`)
          .then(response => response.json())
          .then(response => {
            productObject.name = response.product.title;
            productObject.brand = response.product.vendor;
            productObject.id = response.product.id;
            productObject.category = response.product.product_type;

            removalObjectInstance.ecommerce['add'] = removalObjectInstance.ecommerce['remove'];
            removalObjectInstance.event = 'eec.addToCart';
            delete removalObjectInstance.ecommerce['remove'];
            $minusBtn.addClass('quantity__button--is-valid');

            dataLayer.push(removalObjectInstance);
          })

        $minusBtn.removeClass('quantity__button--is-valid');
      } else {
        // Minus button
        if ($minusBtn.hasClass('quantity__button--is-valid')) {
          fetch(`${window.theme.routes.root_url}products/${productHandle}.json`)
            .then(response => response.json())
            .then(response => {
              productObject.name = response.product.title;
              productObject.brand = response.product.vendor;
              productObject.id = response.product.id;
              productObject.category = response.product.product_type;

              dataLayer.push(removalObjectInstance);
            })

          if (storedQunatityInputValue == 1) {
            $minusBtn.removeClass('quantity__button--is-valid');
          }
        }
      }
    }
  }
})(jQuery);
